// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"763fba0b","555":"5bb4d031","608":"c4d62f05","737":"aa46b1d2","835":"baa1e8b9"}[chunkId] + ".chunk.css";
};